import styled from '@emotion/styled';

export const ChartContainer = styled.div({
  width: '100%',
  height: '300px',
  '[data-analytics-fullscreen] &': {
    height: '100%',
  },
});

export const ChartWithAxes = styled.div({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gridTemplateRows: '1fr auto',
  gridTemplateAreas: `
    "y-select chart-area"
    ".        x-select"
  `,
  gap: 0,
  position: 'relative',
  '[data-analytics-fullscreen] &': {
    flex: 1,
    minHeight: 0,
  },
});

export const YAxisSelectArea = styled.div(({ theme }) => ({
  gridArea: 'y-select',
  display: 'flex',
  alignItems: 'center',
  paddingRight: '0.5rem',
  '& .axis-label': {
    writingMode: 'vertical-lr',
    transform: 'rotate(180deg)',
    fontSize: '0.7rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.06em',
    userSelect: 'none' as const,
    marginRight: '0.35rem',
  },
}));

export const AxisSelect = styled.div(({ theme }) => ({
  '& .MuiSelect-select': {
    padding: '4px 28px 4px 8px !important',
    fontSize: '0.78rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
  '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: '1.5px',
  },
}));

export const ChartArea = styled.div({
  gridArea: 'chart-area',
  position: 'relative',
  minHeight: '300px',
  overflowX: 'auto',
  '[data-analytics-fullscreen] &': {
    minHeight: 0,
  },
});

export const ChartFloatingControls = styled.div(({ theme }) => ({
  position: 'absolute',
  top: '0.25rem',
  right: '0.25rem',
  display: 'flex',
  gap: '0.35rem',
  alignItems: 'center',
  zIndex: 2,
  '[data-analytics-fullscreen] &': {
    top: '0.5rem',
    right: '4rem',
  },
  '& .MuiSelect-select': {
    padding: '2px 24px 2px 6px !important',
    fontSize: '0.72rem',
    color: theme.palette.text.secondary,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(15, 23, 42, 0.08)',
  },
  '& .MuiInputBase-root': {
    background: 'rgba(255,255,255,0.88)',
    backdropFilter: 'blur(4px)',
    borderRadius: '6px',
  },
}));

export const XAxisSelectArea = styled.div(({ theme }) => ({
  gridArea: 'x-select',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.4rem',
  paddingTop: '0.4rem',
  '& .axis-label': {
    fontSize: '0.7rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.06em',
    userSelect: 'none' as const,
  },
}));

export const PieSelectsRow = styled.div(({ theme }) => ({
  gridColumn: '1 / -1',
  display: 'flex',
  justifyContent: 'center',
  gap: '1.5rem',
  paddingTop: '0.5rem',
  '& .axis-group': {
    display: 'flex',
    alignItems: 'center',
    gap: '0.35rem',
  },
  '& .axis-label': {
    fontSize: '0.7rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.06em',
    userSelect: 'none' as const,
  },
}));
